import React from "react";
import "antd/dist/antd.min.css";

import { Layout } from "antd";

const { Footer } = Layout;

const Footer2 = () => {
  return (
    <Footer style={{ textAlign: "center" }}>
      Copyright &copy; 2022 Research RIHES CMU
    </Footer>
  );
};
export default Footer2;